/* Optional personalization failure never blocks the native product page. */
(() => {
 'use strict';
 const pending = new WeakSet();
 async function load(info) {
  const box=info.querySelector('[data-upsell-kind="pdp"]'), list=box?.querySelector('[data-upsell-list]');
  if (!list || pending.has(info)) return;
  const product=info.closest('[data-product-section]');
  if (!product?.dataset.productUrl) return;
  pending.add(info);
  try {
   const url=new URL(product.dataset.productUrl,location.origin);
   if(url.origin!==location.origin)return;
   url.searchParams.set('section_id','cc-embroidery');
   url.searchParams.set('variant',info.dataset.variantId);
   const preview=new URL(location.href).searchParams.get('preview_theme_id');
   if(preview)url.searchParams.set('preview_theme_id',preview);
   const response=await fetch(url,{credentials:'same-origin'});
   if(!response.ok)throw Error('personalization');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   if(!info.isConnected)return;
   for(const card of doc.querySelectorAll('[data-personalization-card]')){
    if(card.querySelector('[name="properties[_citycar_parent_variant]"]')?.value!==info.dataset.variantId)continue;
    if(list.querySelector(`[data-addon-product="${card.dataset.addonProduct}"]`))continue;
    list.append(card);
   }
   window.CITYCAR?.sortAddons?.(list);
   box.hidden=!list.children.length;
   document.dispatchEvent(new Event('citycar:translated-content'));document.dispatchEvent(new Event('citycar:addons-ready'));
  }catch{pending.delete(info);}
 }
 const populate=()=>document.querySelectorAll('[data-product-info]').forEach(load);
 document.addEventListener('change',e=>{
  const select=e.target.closest('[data-embroidery-variant]');if(!select)return;
  const price=select.closest('[data-personalization-card]')?.querySelector('[data-embroidery-price]');
  if(price&&select.selectedOptions[0]?.dataset.price)price.textContent=select.selectedOptions[0].dataset.price;
 });
 ['citycar:content-updated','shopify:section:load'].forEach(e=>document.addEventListener(e,populate));
 populate();
})();
